(function(root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.IBProductFacts = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function() {
  'use strict';

  function text(value) {
    return value === null || value === undefined ? '' : String(value).trim();
  }

  function isPresent(value) {
    return text(value) !== '';
  }

  function isZeroSugar(nutrition) {
    var raw = text((nutrition || {}).sugar).toLowerCase();
    if (!raw || raw.charAt(0) === '<') return false;
    var match = raw.match(/^0(?:\.0+)?\s*(?:g)?$/);
    return !!match;
  }

  function hasVerifiedNutrition(product) {
    var nutrition = (product || {}).nutrition || {};
    var glutenStatus = text(nutrition.glutenStatus);
    return isPresent(nutrition.kcal) &&
      isPresent(nutrition.sugar) &&
      isPresent(nutrition.carbs) &&
      isPresent(nutrition.ingredients) &&
      isPresent(nutrition.allergens) &&
      glutenStatus !== '' && glutenStatus !== 'unknown' &&
      isPresent(nutrition.sourceDocument) &&
      isPresent(nutrition.verifiedAt);
  }

  function isLaunchReady(product) {
    return !!product &&
      isPresent(product.variantSku) &&
      isPresent(product.variantId) &&
      product.variantAvailable === true &&
      hasVerifiedNutrition(product);
  }

  function deriveCustomerTags(product) {
    var tags = [];
    var nutrition = (product || {}).nutrition || {};
    var badge = (text(product && (product.badgeType || product.badge))).toLowerCase();
    if (badge.indexOf('limited') !== -1 || product.isLimited === true) tags.push('le');
    if (text(nutrition.glutenStatus) === 'gluten_free_under_20ppm') tags.push('gf');
    if (isZeroSugar(nutrition)) tags.push('zs');
    if (text(nutrition.allergens).toLowerCase().indexOf('lactose') !== -1) tags.push('lact');
    if (nutrition.vegan === true) tags.push('vegan');
    return tags;
  }

  function mergeProductsLastWins(items) {
    var order = [];
    var byId = Object.create(null);
    (items || []).forEach(function(product) {
      if (!product || !product.id) return;
      if (!Object.prototype.hasOwnProperty.call(byId, product.id)) order.push(product.id);
      byId[product.id] = product;
    });
    return order.map(function(id) { return byId[id]; });
  }

  function nutritionDisplay(product) {
    if (!hasVerifiedNutrition(product)) {
      return { verified: false, label: 'Nutrition not yet verified' };
    }
    var nutrition = product.nutrition;
    return {
      verified: true,
      kcal: text(nutrition.kcal),
      sugar: text(nutrition.sugar),
      carbs: text(nutrition.carbs),
      ingredients: text(nutrition.ingredients),
      allergens: text(nutrition.allergens),
      glutenStatus: text(nutrition.glutenStatus),
      vegan: nutrition.vegan === true,
      sourceDocument: text(nutrition.sourceDocument),
      verifiedAt: text(nutrition.verifiedAt)
    };
  }

  return {
    deriveCustomerTags: deriveCustomerTags,
    hasVerifiedNutrition: hasVerifiedNutrition,
    isLaunchReady: isLaunchReady,
    isZeroSugar: isZeroSugar,
    mergeProductsLastWins: mergeProductsLastWins,
    nutritionDisplay: nutritionDisplay
  };
});
